import React, { useState } from 'react';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../store/auth-context';
import FormBtn from '../Form/FormBtn';
import TextField from '../Form/TextField';

const AdminLogin = () => {
  const context = useContext(AuthContext);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const emailChangeHandler = (data) => {
    setEmail(data);
  };

  const passwordChangeHandler = (data) => {
    setPassword(data);
  };

  const onLogin = (e) => {
    e.preventDefault();

    fetch('https://aifolio-api.herokuapp.com/api/user/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        password: password,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        getUserData(data.accessToken);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getUserData = (token) => {
    fetch('https://aifolio-api.herokuapp.com/api/user/get/single', {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.isAdmin) {
          localStorage.setItem('token', token);
          localStorage.setItem('isAdmin', data.isAdmin);
          context.isAdminHandler(data);
          context.logoutHandler(true);
          navigate('/admin');
        } else {
          localStorage.setItem('token', token);
        }
      })
      .catch((err) => console.log(err));
  };

  return (
    <>
      {!context.isLoggedIn && (
        <div className='admin-screen__border-inner'>
          <form className='form' onSubmit={onLogin}>
            <TextField
              label='email'
              inputHandler={emailChangeHandler}
              value={email}
              type='text'
            />
            <TextField
              label='Password'
              inputHandler={passwordChangeHandler}
              value={password}
              type='password'
            />
            <FormBtn value='Login' type='submit' />
          </form>
        </div>
      )}
    </>
  );
};

export default AdminLogin;
